class Audio {
  constructor() {
    this.audioEls = document.querySelectorAll('.js-audio');
    this.playingClasses = ['is-playing', '--pause'];
    this.activeClass = 'is-active';
    this.init();
  }

  init() {
    if (!this.audioEls.length) return;

    this.audioEls.forEach((component) => {
      const source = component.querySelector('.js-audio-source');
      const playBtn = component.querySelector('.js-audio-play');
      const fill = component.querySelector('.js-audio-fill');
      const timeCurrent = component.querySelector('.js-audio-time-current');
      const timeTotal = component.querySelector('.js-audio-time-total');
      const track = component.querySelector('.js-audio-track');
      const items = component.querySelectorAll('.js-audio-item');

      if (!source || !playBtn) return;

      // プレイリスト：アイテムクリックで音源を切り替えて再生
      items.forEach((item) => {
        item.addEventListener('click', () => {
          items.forEach((i) => i.classList.remove(this.activeClass));
          item.classList.add(this.activeClass);
          this.loadTrack(source, item.dataset.src, playBtn);
        });
      });

      // 再生・一時停止ボタン
      playBtn.addEventListener('click', () => {
        if (!source.src) return;
        this.togglePlay(source, playBtn);
      });

      // 再生位置の更新（進捗バー・現在時間）
      source.addEventListener('timeupdate', () => {
        this.updateProgress(source, fill, timeCurrent);
      });

      // メタデータ取得後に総時間を表示
      source.addEventListener('loadedmetadata', () => {
        timeTotal.textContent = this.formatTime(source.duration);
      });

      // 再生終了：UIをリセット
      source.addEventListener('ended', () => {
        playBtn.classList.remove(...this.playingClasses);
        fill.style.width = '0%';
        timeCurrent.textContent = '00:00';
      });

      // プログレスバークリックでシーク
      track.addEventListener('click', (e) => {
        if (!source.src || !source.duration) return;
        this.seek(e, track, source, fill, timeCurrent);
      });

      // 初期アクティブアイテムを音源にセット（自動再生はしない）
      const activeItem = component.querySelector(`.js-audio-item.${this.activeClass}`);
      if (activeItem) {
        source.src = activeItem.dataset.src;
        source.load();
      }
    });
  }

  loadTrack(source, src, playBtn) {
    source.src = src;
    source.load();
    source.play();
    playBtn.classList.add(...this.playingClasses);
  }

  togglePlay(source, playBtn) {
    if (source.paused) {
      source.play();
      playBtn.classList.add(...this.playingClasses);
    } else {
      source.pause();
      playBtn.classList.remove(...this.playingClasses);
    }
  }

  updateProgress(source, fill, timeCurrent) {
    const { currentTime, duration } = source;
    if (!duration) return;
    fill.style.width = `${(currentTime / duration) * 100}%`;
    timeCurrent.textContent = this.formatTime(currentTime);
  }

  seek(e, track, source, fill, timeCurrent) {
    const rect = track.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    source.currentTime = Math.max(0, Math.min(ratio, 1)) * source.duration;
    this.updateProgress(source, fill, timeCurrent);
  }

  formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
}

export default Audio;
